/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Builder_EndInputs */

const en_cp_builder_end = /** @type {(inputs: Cp_Builder_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demo day + pitch. The proposal PDF and readiness score become attachments for grant applications.`)
};

const id_cp_builder_end = /** @type {(inputs: Cp_Builder_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demo day + pitch. Proposal PDF dan skor kesiapan jadi lampiran P2MW/PKM.`)
};

/**
* | output |
* | --- |
* | "Demo day + pitch. The proposal PDF and readiness score become attachments for grant applications." |
*
* @param {Cp_Builder_EndInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_builder_end = /** @type {((inputs?: Cp_Builder_EndInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Builder_EndInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_builder_end(inputs)
	return en_cp_builder_end(inputs)
});